import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { finalize } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { handleFileUploaded, handleFileUploadError } from 'src/app/shared/components/upload-input/file-upload-helper';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';

@Component({
  selector: 'app-lga-settings-modal',
  templateUrl: './lga-settings-modal.component.html',
  styleUrls: ['./lga-settings-modal.component.css'],
  standalone: false,
})
export class LgaSettingsModalComponent implements OnInit {
  lgaDetails?: any;
  isInPreviewMode?: boolean;
  isEditingAllowed?: boolean = true;

  isSearching: boolean
  years: number[] = []; // Array to hold year options
  @ViewChild("logoUploadInput", { static: false })
  logoUploadInput!: ElementRef<HTMLInputElement>;

  @ViewChild("signatureUploadInput", { static: false })
  signatureUploadInput!: ElementRef<HTMLInputElement>;

  constructor(private formBuilder: FormBuilder, private dialog: MatDialog,
    public dialogRef: MatDialogRef<LgaSettingsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService, private authService: AuthService) {

  }
  form: FormGroup

  ngOnInit(): void {
    this.initForm();

    this.lgaDetails = this.dialogData?.lgaDetails;
    this.isInPreviewMode = this.dialogData?.isInPreviewMode;

    if (this.dialogData?.isInPreviewMode) {
      this.populateExistingData()
    }

    this.fetchLgaList()

  }





  private initForm(): void {
    this.form = this.formBuilder.group({
      logo: [null, Validators.required],
      acronym: [null, Validators.required],
      headName: [null, Validators.required],
      lga: [null, Validators.required],
      headSignature: [null, Validators.required],
      lgaBg: [null, Validators.required],
      description: [null, Validators.required],
      address: [null, Validators.required],
      headTitle: [null, Validators.required],
      primaryBackgroundColor: ["", Validators.required],
      secondaryBackgroundColor: ["", Validators.required],
      primaryTextColor: ["", Validators.required],
      secondaryTextColor: ["", Validators.required],
      website: [null, [Validators.pattern('https?://.+')]],
      departments: [null],
    });
  }


  lgaList: any[]
  populateExistingData() {
    if (this.lgaDetails) {
      this.form.patchValue({
        logo: { file: null, readableUrl: this.lgaDetails?.logo },
        lga: this.lgaDetails?.departmentId,
        acronym: this.lgaDetails?.acronym || 'nil',
        address: this.lgaDetails?.address,
        description: this.lgaDetails?.description,
        lgaBg: { file: null, readableUrl: this.lgaDetails.lgaBgURL },
        primaryBackgroundColor: this.lgaDetails?.primaryBackgroundColor,
        secondaryBackgroundColor: this.lgaDetails?.secondaryBackgroundColor,
        primaryTextColor: this.lgaDetails?.primaryTextColor,
        secondaryTextColor: this.lgaDetails?.secondaryTextColor,
        website: this.lgaDetails?.website,
        departments: this.lgaDetails?.department,
        headName: this.lgaDetails?.headName,
        headTitle: this.lgaDetails?.headTitle,
        headSignature: { file: null, readableUrl: this.lgaDetails?.headSignature },
      })

      this.form.disable();
      this.isEditingAllowed = false;

    }
  }

  allowEditing() {
    this.isEditingAllowed = true;
    this.form.enable()
  }



  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  fetchLgaList() {
    this.apiService
      .get('/utility/all/lga')
      .subscribe((response: any) => {
        const existingLgas = this.dialogData?.existingLgaSettings?.map(item => item.department);

        this.lgaList = response.filter(item => !existingLgas?.includes(item.name));

      });
  }


  mdaList: any[]
  fetchMDADetails(): void {
    const url =
      "/auth/mda/get/mda";
    this.apiService.get(url).subscribe(res => {
      this.mdaList = res.data
    });
  }



  search() {
  }

  private generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 1900; // Define the earliest reasonable year
    this.years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear - i); // Generate years in descending order
  }



  showLogoErrorMessage: boolean = false;
  onLogoChange(event: Event): void {

    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];


      if (file.size <= 1 * 1024 * 1024) {

        const uploadedImageUrl = URL.createObjectURL(file);
        this.form?.patchValue({ logo: { file, readableUrl: uploadedImageUrl } });
        this.form.markAsDirty();
      }
      else {
        input.value = null
        this.showLogoErrorMessage = true
        this.logoUploadControl.setErrors({ maxFileSize: true })
      }

    }
  }


  get logoUploadControl() {
    return this.form.get('logo') as FormControl
  }

  get signatureUploadControl() {
    return this.form.get('headSignature') as FormControl
  }

  uploadIsAnImage() {

  }

  showErrorMessages: boolean = false;
  showSignatureErrorMessage: boolean = false;

  onSignatureChange(event: Event): void {
    this.showSignatureErrorMessage = false

    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];

      if (file.size <= 1 * 1024 * 1024) {

        const uploadedSignatureUrl = URL.createObjectURL(file);

        this.form?.patchValue({ headSignature: { file, readableUrl: uploadedSignatureUrl } });
        this.form.markAsDirty();
      } else {
        input.value = null
        this.showSignatureErrorMessage = true
        this.signatureUploadControl.setErrors({ maxFileSize: true })
      }
    }
  }


  clearUploadedSignature() {
    this.form?.patchValue({ headSignature: null });
    this.signatureUploadInput.nativeElement.value = null
  }

  isImage(file: File): boolean {
    const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'];
    return validImageTypes?.includes(file?.type);
  }

  isImageUrl(url: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const pattern = new RegExp(`\\.(${imageExtensions.join('|')})$`, 'i');
    return pattern.test(url);
  }


  triggerUploadLogo() {
    if (this.isEditingAllowed) {
      this.form?.patchValue({ logo: null });
      this.logoUploadInput.nativeElement.value = null
      this.logoUploadInput.nativeElement.click();
    }
  }

  triggerSignatureUpload() {
    this.clearUploadedSignature()
    this.signatureUploadInput.nativeElement.click();
  }

  convertToBase64(file: File | null): Promise<string> {
    return new Promise((resolve, reject) => {
      if (file && file instanceof File) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result as string;
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file); // Proceed with the conversion if file is valid
      } else {
        reject(new Error("The provided input is not a valid file."));
      }
    });
  }

  close(data?: any) {
    this.dialogRef.close()
  }

  isSubmitting: boolean = false;

  onFileChange(
    fileDetails: { file: File; readableUrl: string } | null,
    controlName: string
  ) {
    handleFileUploaded(fileDetails, this.form, controlName);
  }

  onError(errorResponse: any, controlName: string) {
    handleFileUploadError(errorResponse, this.form, controlName);
  }


  private mapRequestBody(formValues: any, extraFields: Partial<any> = {}): any {
    return {
      logo: null,
      lga: formValues.lga,
      headSignature: null,
      acronym: formValues.acronym,
      headName: formValues.headName,
      headTitle: formValues.headTitle,
      lgaBgURL: null,
      primaryBackgroundColor: formValues.primaryBackgroundColor,
      secondaryBackgroundColor: formValues.secondaryBackgroundColor,
      primaryTextColor: formValues.primaryTextColor,
      secondaryTextColor: formValues.secondaryTextColor,
      website: formValues.website,
      description: formValues.description,
      address: formValues.address,
      ...extraFields, // Merge any extra fields like `id`
    };
  }

  async submit() {
    if (this.form.valid) {
      this.isSubmitting = true;
      const formValues = this.form.getRawValue();
      let requestBody = this.mapRequestBody(formValues, { departments: formValues.mda });

      try {
        const headSignatureBase64 = formValues.headSignature?.file
          ? await this.convertToBase64(formValues.headSignature.file)
          : null;

        const logoBase64 = formValues.logo?.file
          ? await this.convertToBase64(formValues.logo.file)
          : null;

        const lgaBgBase64 = formValues.lgaBg?.file
          ? await this.convertToBase64(formValues.lgaBg.file)
          : null;

        requestBody = { ...requestBody, headSignature: headSignatureBase64, logo: logoBase64, lgaBgURL: lgaBgBase64 };
      } catch (error) {
        console.error('Error converting file to base64:', error);
      }

      this.apiService.post('/settings/config/create', requestBody)
        .pipe(finalize(() => (this.isSubmitting = false)))
        .subscribe(
          (res) => {
            if (res.success) {
              this.openSuccessModal(res.message);
              this.close();
            } else {
              this.openErrorModal(res.message);
            }
          },
          (err) => {
            this.openErrorModal(err);
          }
        );
    } else {
      this.showErrorMessages = true;
    }
  }



  async edit() {
    if (this.form.valid) {
      this.isSubmitting = true;
      const formValues = this.form.getRawValue();
      let requestBody = this.mapRequestBody(formValues, { departments: formValues.mda });

      try {
        const headSignatureBase64 = formValues.headSignature?.file
          ? await this.convertToBase64(formValues.headSignature.file)
          : this.isUrl(formValues?.headSignature?.readableUrl)
            ? await this.convertUrlToBase64(formValues?.headSignature?.readableUrl)
            : null;

        const logoBase64 = formValues.logo?.file
          ? await this.convertToBase64(formValues.logo.file)
          : this.isUrl(formValues.logo.readableUrl)
            ? await this.convertUrlToBase64(formValues.logo.readableUrl)
            : null;

        // const lgaBgBase64 = formValues.lgaBg?.file
        //   ? await this.convertToBase64(formValues.lgaBg.file)
        //   : null;

          const lgaBgBase64 = formValues.lgaBg?.file
          ? await this.convertToBase64(formValues.lgaBg.file)
          : this.isUrl(formValues.lgaBg.readableUrl)
            ? await this.convertUrlToBase64(formValues.lgaBg.readableUrl)
            : null;

        requestBody = { ...requestBody, headSignature: headSignatureBase64, logo: logoBase64, id: this.lgaDetails.id, lgaBgURL: lgaBgBase64 };
      } catch (error) {
        console.error('Error converting file to base64:', error);
      }

      this.apiService.post('/settings/config/create', requestBody)
        .pipe(finalize(() => (this.isSubmitting = false)))
        .subscribe(
          (res) => {
            if (res.success) {
              this.openSuccessModal(res.message);
              this.close();
            } else {
              this.openErrorModal(res.message);
            }
          },
          (err) => {
            console.error(err);
            this.openErrorModal('Error editing LGA settings: ' + err);
          }
        );
    } else {
      this.showErrorMessages = true;
    }
  }

  isUrl(value: string): boolean {
    return typeof value === 'string' && value.startsWith('http');
  }

  async convertUrlToBase64(url: string): Promise<string> {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);

      });
    } catch (error) {
      console.error('Error fetching image:', error);
      return null;
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }


}
